import React, { JSXElementConstructor, ReactElement, ReactNode } from 'react';

interface IProps {
  children: ReactElement<undefined, string> | JSXElementConstructor<string> | ReactNode;
  isSelected: boolean;
}

const Tab: React.FC<IProps> = ({ children, isSelected }): JSX.Element => {
  return <> {isSelected ? children : null}</>;
};

export default Tab;
